export const maxFileSize = 15;

export const maxTotalFilesSize = 15;

export const maxNumberOfFiles = 5;

export const columnGridCount = 12;

export const allowedMimeTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/x-png',
    'image/jpe',
    'image/jpg',
    'image/jpeg',
    'image/png',
];

export const PRODUCT_SELECT_LABELS = [
    'contact_form.contact.product.select_option.paysera_pos',
    'contact_form.contact.product.select_option.paysera_checkout',
    'contact_form.contact.product.select_option.paysera_tickets',
    'contact_form.contact.product.select_option.mass_payments_via_api',
    'contact_form.contact.product.select_option.other',
];

export const VALIDATION_LIMITS = {
    NAME_MIN_LENGTH: 2,
    NAME_MAX_LENGTH: 54,
    COMPANY_NAME_MIN_LENGTH: 2,
    COMPANY_NAME_MAX_LENGTH: 100,
    MESSAGE_MIN_LENGTH: 5,
    MESSAGE_MAX_LENGTH: 5000,
};

export const FIELD_NAMES = {
    name: 'name',
    email: 'email',
    companyName: 'companyName',
    product: 'product',
    message: 'message',
    attachments: 'attachments',
};

export const VALIDATION_RULES = {
    required: 'required',
    minLength: 'minLength',
    maxLength: 'maxLength',
    email: 'email',
};

export const VALIDATION_ERROR_KEYS = {
    required: 'contact_form.validate.required',
    emailNotValid: 'contact_form.validate.email_not_valid',
    short: (length) => `contact_form.validate.short_${length}`,
    long: (length) => `contact_form.validate.long_${length}`,
};

export const RULES = {
    [VALIDATION_RULES.required]: (value) => {
        if (!value || !value.trim()) {
            return VALIDATION_ERROR_KEYS.required;
        }

        return null;
    },

    [VALIDATION_RULES.minLength]: (value, minLength) => {
        if (value && value.trim().length < minLength) {
            return VALIDATION_ERROR_KEYS.short(minLength);
        }

        return null;
    },

    [VALIDATION_RULES.maxLength]: (value, maxLength) => {
        if (value && value.trim().length > maxLength) {
            return VALIDATION_ERROR_KEYS.long(maxLength);
        }

        return null;
    },

    [VALIDATION_RULES.email]: (value) => {
        if (!value?.trim() || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
            return VALIDATION_ERROR_KEYS.emailNotValid;
        }

        return null;
    },
};

export const VALIDATION_SCHEMA = {
    [FIELD_NAMES.name]: [
        { rule: VALIDATION_RULES.required },
        { rule: VALIDATION_RULES.minLength, value: VALIDATION_LIMITS.NAME_MIN_LENGTH },
        { rule: VALIDATION_RULES.maxLength, value: VALIDATION_LIMITS.NAME_MAX_LENGTH },
    ],
    [FIELD_NAMES.email]: [
        { rule: VALIDATION_RULES.required },
        { rule: VALIDATION_RULES.email },
    ],
    [FIELD_NAMES.companyName]: [
        { rule: VALIDATION_RULES.required },
        { rule: VALIDATION_RULES.minLength, value: VALIDATION_LIMITS.COMPANY_NAME_MIN_LENGTH },
        { rule: VALIDATION_RULES.maxLength, value: VALIDATION_LIMITS.COMPANY_NAME_MAX_LENGTH },
    ],
    [FIELD_NAMES.product]: [
        { rule: VALIDATION_RULES.required },
    ],
    [FIELD_NAMES.message]: [
        { rule: VALIDATION_RULES.required },
        { rule: VALIDATION_RULES.minLength, value: VALIDATION_LIMITS.MESSAGE_MIN_LENGTH },
        { rule: VALIDATION_RULES.maxLength, value: VALIDATION_LIMITS.MESSAGE_MAX_LENGTH },
    ],
};

export const RECIPIENTS = {
    support: 'support',
};

export const BASE_CONTACTUS_MESSAGE_SUBJECT = 'Business service request -';
